export const ForDocumentDetails = {
  PUBLIC: 'public',
  PRIVATE: 'private',
};
